module.exports = __webpack_public_path__ + "img/serviceImg1.c9c0bd89.png";